import WrapApp from "./WrapApp";

export default WrapApp;
